module.exports = __webpack_public_path__ + "d4970a0f659c31741888310a7d6871d5.png";